export default __webpack_public_path__ + "static/media/flame.0df5f274.svg";